
<template>
  <div>
   <v-row justify="center">
             <v-dialog
               v-model="dialog"
               persistent
               max-width="490"
             >

               <v-card>
                 <v-card-title class="text-h5" style="background-color:#006699;color:white;">
                   Seleção do trimestre
                 </v-card-title>
                 <v-card-text>
                   <v-row>
                     <v-col md="12"></v-col>
                     <v-col md="12"></v-col>
                     <v-col md="12">
                       <v-row>
                         <v-col md="2"></v-col>
                         <v-col md="8">
                           <v-select
                           v-model="trimestre"
                           item-value="id"
                           item-text="descricao"
                           :items="trimestres"
                           filled
                           color="blue-grey lighten-2"
                           label="Trimestre"
                           outlined
                           return-object
                         ></v-select>
                         </v-col>
                       </v-row>
                     </v-col>
                    </v-row>
                 </v-card-text>
                 <v-card-actions>
                   <v-spacer></v-spacer>
                   <v-btn
                     color="darken-1"
                     text
                     @click="sair()"
                   >
                     Fechar
                   </v-btn>
                   <v-btn
                     color="green darken-1"
                     text
                     :disabled="trimestre.id === 0"
                     @click="getMeses()"
                    >
                     Continuar
                   </v-btn>
                 </v-card-actions>
               </v-card>
             </v-dialog>
           </v-row>
 </div>
     </template>

<script>
import utilitariosImpressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
import axios from '../../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    dialog: true,
    trimestre: { id: 0, descricao: '' },
    trimestres: [{
      id: 1,
      descricao: '1º Trimestre'
    },
    {
      id: 2,
      descricao: '2º Trimestre'
    },
    {
      id: 3,
      descricao: '3º Trimestre'
    }
    ],
    meses: [],
    logotipo: ls.get('logotipo'),
    configuracoesReport: [],
    isLoading: false,
    readfile: '',
    mes2: '',
    mes3: '',
    mes4: '',
    backTo: null,
    disciplina: ls.get('disciplinaobj'),
    relatorio: []
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    role () {
      return ls.get('role')
    },
    isIlha () {
      return (ls.get('i_id') === 24 || ls.get('i_id') === 17 ? 1 : 0)
    }
  },

  watch: {
  },
  created () {
  },

  methods: {
    async carregarRelatorio (param) {
      try {
        this.relatorio = await axios
          .get('/obterRelatorioByDescricao/' + param)
          .then(res => res.data)
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao carregar o relatório'
        })
      }
    },
    async getMeses () {
      try {
        if (this.trimestre.id === 2) {
          this.carregarRelatorio('mca2')
        } else {
          this.carregarRelatorio('mca')
        }
        this.meses = await axios.get('/getMesesTrimestre/' + this.trimestre.id).then(res => res.data)
        this.dialog = false
        this.htmlToPDF()
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao tentar efectuar a operação', 'error')
      }
    },
    async htmlToPDF () {
      try {
        this.html = this.relatorio[0].documento
        let documentoiter = this.relatorio[0].documentoiteracao1
        this.html = this.html.replace(/{{instituicaodescricao}}/g, ls.get('instituicaodescricao').toUpperCase())
        this.html = this.html.replace(/{{insignia}}/g, ls.get('logotipo'))
        this.html = this.html.replace(/{{turma}}/g, (this.$store.state.disciplinaTurma.turma ? this.$store.state.disciplinaTurma.turma : this.$store.state.disciplinaTurma.turmadescricao))
        this.html = this.html.replace(/{{curso}}/g, this.$store.state.disciplinaTurma.curso)
        this.html = this.html.replace(/{{classe}}/g, this.disciplina.classe)
        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.disciplinaTurma.anoLectivo)
        this.html = this.html.replace(/{{disciplina}}/g, this.disciplina.descricao)
        this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
        this.html = this.html.replace(/{{periodo}}/g, this.$store.state.disciplinaTurma.periodo)

        this.html = this.html.replace(/{{mes1}}/g, (this.meses.length >= 1 ? this.meses[0].descricao : ''))
        this.html = this.html.replace(/{{mes2}}/g, (this.meses.length >= 2 ? this.meses[1].descricao : ''))
        this.html = this.html.replace(/{{mes3}}/g, (this.meses.length >= 3 ? this.meses[2].descricao : ''))
        this.html = this.html.replace(/{{mes4}}/g, (this.meses.length >= 4 ? this.meses[3].descricao : ''))

        let i = 1
        let dados = ``

        this.$store.state.minipauta.notas.forEach(element => {
          let mac = (this.trimestre.id === 1 ? (!element.t1_mac || element.t1_mac === null ? '' : element.t1_mac) : this.trimestre.id === 2 ? (!element.t2_mac || element.t2_mac === null ? '' : element.t2_mac) : this.trimestre.id === 3 ? (!element.t3_mac || element.t3_mac === null ? '' : element.t3_mac) : '')

          let iteracao = documentoiter
          iteracao = iteracao.replace(/{{nomeAluno}}/g, element.nome.toUpperCase())
          iteracao = iteracao.replace(/{{indice}}/g, i)
          iteracao = iteracao.replace(/{{mac}}/g, mac)
          dados += iteracao
          i++
        })
        this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
        this.html = this.html.replace(/{{dados}}/g, dados)
        let option = { 'format': 'A4',
          'orientation': 'landscape',
          'border': {
            'right': '15mm',
            'left': '15mm'
          },
          'header': {
            'height': '10mm' },
          'footer': {
            'height': '10mm'
          } }

        utilitariosImpressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
        this.$store.state.showDialogGuia.mapacontrolavaliacaocontinua.componente = false
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro ao compor o documento'
        })
      }
    },
    sair () {
      this.dialog = false
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.mapacontrolavaliacaocontinua.componente = false
    },

    retornaMes () {
      if (this.disciplina.trimestre.idTrimestre === 1) {
        this.mes1 = 'Setembro'
        this.mes2 = 'Outubro'
        this.mes3 = 'Novembro'
        this.mes4 = 'Dezembro'
      } else if (this.disciplina.trimestre.idTrimestre === 2) {
        this.mes1 = 'Janeiro'
        this.mes2 = 'Fevereiro'
        this.mes3 = 'Março'
        this.mes4 = 'Abril'
      } else if (this.disciplina.trimestre.idTrimestre === 3) {
        this.mes1 = 'Maio'
        this.mes2 = 'Junho'
        this.mes3 = 'Julho'
        this.mes4 = 'Agosto'
      }
    }

  }
}
</script>
